import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {openDrawer} from '../components/drawer/entitlement-drawer.slice';
import {EntitlementType} from '../components/drawer/typedef';

export const useOpenEntitlementDrawer = () => {
    const dispatch = useDispatch();

    const openResourceDrawer = useCallback((resourceId: string) => {
        dispatch(openDrawer({entitlementType: EntitlementType.RESOURCE, entitlementId: resourceId}));
    }, [dispatch]);

    const openGrantDrawer = useCallback((grantId: string) => {
        dispatch(openDrawer({entitlementType: EntitlementType.GRANT, entitlementId: grantId}));
    }, [dispatch]);

    const openRoleDrawer = useCallback((roleId: string) => {
        dispatch(openDrawer({entitlementType: EntitlementType.ROLE, entitlementId: roleId}));
    }, [dispatch]);

    return {openResourceDrawer, openGrantDrawer, openRoleDrawer};
};
